import {Component} from '@angular/core';
import {Events} from 'ionic-angular';
import {Api} from "../../providers/api";
import { NavController, NavParams ,AlertController,ModalController,ToastController} from 'ionic-angular';
import * as _ from "underscore";
import {WebstoreUserAddPage} from "../webstore-user-add/webstore-user-add";
import {UsersAddPopup} from "../users-add-popup/users-add-popup";
import {CartManager} from "../../providers/cart-manager";
import {MsgManager} from "../../providers/msg-manager";
import {SpinnerDialog} from "ionic-native";
import {GVLogger} from "../../services/gv-logger";


@Component({
  selector: 'users',
  templateUrl: 'users.html'
})
export class UsersPage{

	private showList: boolean;
	private customers:any = [];
	private searchQuery:any;


	constructor(
		private api:Api,
		private nav:NavController,
		private modalController:ModalController,
		private cartManager:CartManager,
		private msgManager:MsgManager,
		private toastController:ToastController,
		private events:Events,
    private gVLogger: GVLogger
		){


		this.searchQuery = "";
		this.events.subscribe('userDataChange',() => {
			this.customers = [];
		    this.searchCustomersLazy(this.searchQuery,0);
		});

		this.events.publish("userDataChange");
		this.showList = true;
	}



	searchCustomersLazy(searchQuery,itemCount){

		return new Promise(resolve=>{



		if(searchQuery == ""){
			searchQuery = " ";
		}

  	var url = "users/searchIntelliRepUsers/"+searchQuery+"/"+itemCount;
    this.gVLogger.log(url);
    // get list items of a category as sample
    this.api.get(url).map(res => res.json())
    .subscribe(data => {
      let temp = this.customers;

      if(!(typeof data === 'undefined') && data ){
          if (data.data && data.data.constructor === Array) {

          } else {
            data.data = [];
          }
        }else{
          data = { data: []};
        }

      for(let cust of data.data){

        temp.push(cust);
      }


      this.customers  = this.arrayUnique(temp);


      this.gVLogger.log(this.customers);
      resolve(true);
      });

    });
}


doInfinite(infiniteScroll){
     this.searchCustomersLazy(this.searchQuery,this.customers.length).then(()=>{
     	infiniteScroll.complete();
     });
}

searchThroughItems(ev: any){
    // Reset items back to all of the items
    // this.initializeCustomers();
    this.gVLogger.log(ev.target.value);
    // Show the results
    this.showList = true;
// set val to the value of the searchbar
    let val = ev.target.value;

    if(ev.target.value!=""){
      this.searchQuery = val;
      this.customers = [];
      this.searchCustomersLazy(this.searchQuery,0);
      }else{
    	  this.searchQuery = " ";
	      this.customers = [];
	      this.searchCustomersLazy(this.searchQuery,0);
      }


    }

    onCancel(ev) {
    this.searchQuery = " ";
      this.customers = [];
      this.searchCustomersLazy(this.searchQuery,0);
    ev.target.value = '';
  }

    arrayUnique(array) {
	    var a = array.concat();
	    for(var i=0; i<a.length; ++i) {
	        for(var j=i+1; j<a.length; ++j) {
	            if(a[i].id === a[j].id)
	                a.splice(j--, 1);
	        }
	    }

	    return a;
	}


	getRandomInt() { // 0 or 1 dummy data
	  return Math.round(Math.random()) ;
	}

	// editCustomerAccess(customer){

	// }



	checkActive(customer){
		let temp = [false,true];
		return 	temp[customer.isActive];
	}

	addCustomer(){
		this.nav.push(WebstoreUserAddPage);
	}

	updateCustomerCred(user){

		if (user.id == this.cartManager.getSalesManId()) {
			this.toastMsg(this.msgManager.getCannotModifySelf());
		} else {
			this.gVLogger.log("Update user Credentials");
			let modal = this.modalController.create(UsersAddPopup, { user: user, button: "UPDATE" });
			modal.onDidDismiss(data => {
				if (data != null) {
					user = data.user;
				}
			});
			modal.present();
		}


	}

	toggleStatus(user){
		let tempState = user.userStatus;
		let tempStateInverse;
		if(tempState == 0){
			tempStateInverse = 1;
		}else{
			tempStateInverse = 0;
		}

		if (tempState == true) {
			tempState = 1
		}else{
			tempState = 0
		}

		let body = {
	        userId: user.id,
	        changeBy: this.cartManager.getSalesPerson().id,
	        userName: user.userName,
	        password: user.password,
	        userStatus: tempState,
	        userEmail: user.email,
	        userFirstName: user.firstName,
	        userLastName: user.lastName,
	        userPhone: user.phone,
	        userRole: user.role
	    };
		SpinnerDialog.show(this.msgManager.getLoadingMsg());
		this.api.post("users/editIntelliRepUser",body).map(res => res.json()).subscribe(result =>{
		if(result.status == "200"){
		this.toastMsg(result.message);
		}else{
			this.gVLogger.log("else called");
			this.toastMsg(result.message);
			user.userStatus = tempStateInverse;
		}
		SpinnerDialog.hide();
		}, error =>{
		this.toastMsg(this.msgManager.getWentWrongMsg());
		user.userStatus = tempStateInverse;
		SpinnerDialog.hide();
		});



	}


toastMsg(msg){
    let taost = this.toastController.create({
        message: msg,
        duration: 3000
    });
    taost.present();
  }


  addUserCred(){
		let modal = this.modalController.create(UsersAddPopup,{ user: null ,button:"CREATE" });
		modal.onDidDismiss(data => {
		});
		modal.present();
	}


}



// WEBPACK FOOTER //
// ./src/pages/users/users.ts